import { useEffect, useState } from "react"
import { maskDateTime, maskValue } from "../../../../util/mask";
import { GetLoans } from "../../../../service/controller/LoanController";
import { useUserData } from "../../../../context/UserDataContext";

export const useLoanContracts = () => {
    const [loan, setLoan] = useState([]);
    const { userData } = useUserData();

    useEffect(() => {
        GetLoans(userData.id, data => {
            const sortedData = data.sort((a, b) => new Date(b.dataAtualizacao) - new Date(a.dataAtualizacao));
            setLoan(sortedData);
        });
    }, [])

    const columns = [
        { accessor: "numeroProposta", header: 'Número Da Proposta' }, //render: actionsColumn
        { accessor: "status", header: 'Status Da Proposta' }, //render: actionsColumn
        { accessor: "valorTotal", header: 'Valor da proposta', render: (value) => maskValue(value) }, //render: actionsColumn
        { accessor: "qtdParcelas", header: 'Qtd. Parcelas', render: (value) => value + 'x' }, //render: actionsColumn
        { accessor: "valorParcela", header: 'Valor Da Parcelas', render: (value) => maskValue(value) }, //render: actionsColumn
        { accessor: "dataAtualizacao", header: 'Data Atualização', render: (value) => maskDateTime(value) }, //render: actionsColumn
        { accessor: "dataCriacao", header: 'Data Da Solicitação', render: (value) => maskDateTime(value) }, //render: actionsColumn
    ]

    return {
        columns,
        loan
    }
}